export function bufferToImageUrlOrPdfUrl(
  buffer: ArrayBuffer,
  isPdf: boolean,
): string {
  const blob = new Blob([buffer], {
    type: isPdf ? 'application/pdf' : 'image/jpeg',
  })
  return URL.createObjectURL(blob)
}

export function bufferToFile(
  buffer: ArrayBuffer,
  name: string,
  mimeType: string,
): Promise<File> {
  const blob = new Blob([buffer], { type: mimeType })
  return Promise.resolve(new File([blob], name, { type: mimeType }))
}

export function decodeBase64ToBlob(file: string): string {
  const sliceSize = 1024
  const byteCharacters = atob(file)
  const bytesLength = byteCharacters.length
  const slicesCount = Math.ceil(bytesLength / sliceSize)
  const byteArrays = new Array(slicesCount)

  for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    const begin = sliceIndex * sliceSize
    const end = Math.min(begin + sliceSize, bytesLength)

    const bytes = new Array(end - begin)
    for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0)
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes)
  }
  const blob = new Blob(byteArrays, { type: 'application/pdf' })

  const url = URL.createObjectURL(blob)

  return url
}
